import { createSidecarMedium } from 'use-sidecar';
export var effectCar = createSidecarMedium();
export var focusHiddenMarker = 'data-focus-on-hidden';



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es2015/medium.js
// module id = 516
// module chunks = 2